import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["prompt"];

  // The massimo_source cookie belongs to a rec prompt prefilled into the box (the digest deep
  // link sets them together). A Home render without that prefill means it was abandoned — drop it
  // so an unrelated typed prompt can't inherit the rec.
  connect() {
    if (!this.hasPromptTarget || !this.promptTarget.value.trim()) {
      this.#clearSourceCookie();
    }
  }

  submit(event) {
    event.preventDefault();
    const prompt = this.promptTarget.value.trim();
    if (!prompt) return;
    this.#startChat(prompt, undefined, this.#consumeSourceCookie());
  }

  insert(event) {
    const prompt = event.params.prompt;
    if (!prompt) return;
    this.promptTarget.value = prompt;
    this.promptTarget.focus();
    this.promptTarget.setSelectionRange(prompt.length, prompt.length);
  }

  submitWithPrompt(event) {
    const prompt = event.params.prompt;
    if (!prompt) return;
    this.#startChat(prompt, event.params.suggestionKey);
  }

  keydown(event) {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      this.submit(event);
    }
  }

  // Hand the prompt to Mo and reload so the chat panel opens with it. The
  // autosubmit flag tells the chat form to send immediately — scoped to this
  // home-page entry point so deep links / "Ask Mo" banners only pre-fill.
  // The prompt rides sessionStorage (not a cookie) so long pastes aren't capped
  // by the ~4KB per-cookie limit; suggestionKey, when set, lets the autosubmitted
  // chat record the home-card click so the suggestion rotates out.
  #startChat(prompt, suggestionKey, source) {
    sessionStorage.setItem("massimo-prompt", prompt);
    sessionStorage.setItem("massimo-fullscreen", "true");
    sessionStorage.setItem("massimo-open", "true");
    sessionStorage.setItem("massimo-chat-id", "new");
    sessionStorage.setItem("massimo-autosubmit", "true");
    if (source) {
      sessionStorage.setItem("massimo-source", source);
    } else {
      // Ordinary prompt — discard any pending rec source so it can't attach to a later chat.
      sessionStorage.removeItem("massimo-source");
      this.#clearSourceCookie();
    }
    if (suggestionKey) {
      sessionStorage.setItem("massimo-suggestion-key", suggestionKey);
    } else {
      sessionStorage.removeItem("massimo-suggestion-key");
    }
    window.location.reload();
  }

  // A digest deep link parks the recommendation eid in a cookie while its prompt sits in the Home
  // box; consume it only when the operator actually submits, so the chat links to the recommendation.
  #consumeSourceCookie() {
    const match = document.cookie.match(/massimo_source=([^;]*)/);
    if (!match) return undefined;
    this.#clearSourceCookie();
    return decodeURIComponent(match[1].replace(/\+/g, " "));
  }

  #clearSourceCookie() {
    document.cookie = "massimo_source=; path=/; max-age=0";
  }
}
